var _path, _path2, _ellipse, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0116 134.782C74.8665 143.727 49.5107 129.017 35.3776 101.927C21.2446 74.8366 23.6863 45.6246 40.8313 36.68C57.9763 27.7354 83.3322 42.4453 97.4652 69.5356C111.598 96.6258 109.157 125.838 92.0116 134.782Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0244 96.228C34.8913 69.1378 37.333 39.9258 54.478 30.9812L40.8311 36.6785C23.6861 45.6231 21.2444 74.8351 35.3775 101.925C49.5105 129.016 74.8664 143.726 92.0114 134.781L102.105 130.567C103.322 130.177 104.509 129.683 105.658 129.084L102.105 130.567C85.1634 136 62.2098 121.502 49.0244 96.228Z",
    fill: "url(#paint0_linear_1339_22721)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0698,
    cy: 80.032,
    rx: 55.3252,
    ry: 35.0145,
    transform: "rotate(62.4488 80.0698 80.032)",
    fill: "url(#paint1_linear_1339_22721)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.115 63.8386C96.9816 36.7483 71.6257 22.0384 54.4807 30.983L44.3876 35.1966C43.17 35.5871 41.9834 36.0805 40.8338 36.6803L44.3876 35.1966C61.3287 29.764 84.2823 44.2621 97.4677 69.5359C111.601 96.6261 109.159 125.838 92.014 134.783L105.661 129.085C122.806 120.141 125.248 90.9288 111.115 63.8386Z",
    fill: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4807 30.983C71.6257 22.0384 96.9816 36.7483 111.115 63.8386C125.248 90.9288 122.806 120.141 105.661 129.085L92.014 134.783C109.159 125.838 111.601 96.6261 97.4677 69.5359C84.2823 44.2621 61.3287 29.764 44.3876 35.1966L44.3885 35.1963M40.8338 36.6803L44.3876 35.1966C43.17 35.5871 41.9834 36.0805 40.8338 36.6803Z",
    fill: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.761 118.311C87.0917 125.408 66.851 113.689 55.5524 92.1346C44.2538 70.5805 46.1756 47.3539 59.8451 40.2565C73.5145 33.1592 93.7551 44.8788 105.054 66.4329C116.352 87.9871 114.431 111.214 100.761 118.311Z",
    fill: "#7551FF",
    fillOpacity: 0.77
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1339_22721",
    x1: 29.7762,
    y1: 47.863,
    x2: 54.5708,
    y2: 130.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1339_22721",
    x1: 24.7446,
    y1: 80.032,
    x2: 135.395,
    y2: 80.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BA9AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin3);
export default __webpack_public_path__ + "static/media/Coin3.22da403b8f4c9dba86e1fa3d245f8c9c.svg";
export { ForwardRef as ReactComponent };